import React, { useState, useEffect, useRef } from 'react'
import { Grid, makeStyles, Box, Switch } from '@material-ui/core'
import ItemBox, { Selectable } from '../ItemBox'
import { fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    alignItems: 'center'
  },
  titleArea: {
    flex: 1
  },
  hint: {
    marginTop: theme.spacing(1),
    fontSize: '0.875rem'
  },
  switch: {
    marginRight: -theme.spacing(1)
  }
}))

const PickupTime = ({
  pickupTime,
  onPickupTimeSelection,
  selected: defaultSelected = false
}) => {
  const [selected, setSelected] = useState(defaultSelected)
  const classes = useStyles()

  const firstRun = useRef(true)
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false
      return
    }
    onPickupTimeSelection(selected)
  }, [selected])

  const toggle = () => {
    setSelected(!selected)
  }

  return (
    <Grid item xs={12}>
      <ItemBox {...{ title: "Voraussichtliche neue Abholzeit", infoText: null, currency: null }}>
        <Box p={2} fontSize='body1.fontSize'>
          <div className={classes.main}>
            <div className={classes.titleArea}>
              <strong>{pickupTime}</strong><br />
              <b className={classes.hint}>Hinweis: Bei gebuchter Mobilität können sich die Kosten erhöhen.</b>
            </div>
            <strong>Kenntnisnahme</strong>
            <Switch
              className={classes.switch}
              checked={selected}
              onChange={toggle}
              value={null}
              inputProps={{ 'aria-label': 'Abholzeit' }}
            />
          </div>
        </Box>
      </ItemBox>
    </Grid>
  )
}

export default PickupTime
